export const SCHEDULER_THEME_STYLES = {
  '--nylas-primary': '#2b2b2b',
  '--nylas-error': '#cc4841',
  '--nylas-error-pressed': '#992222',
  '--nylas-wraning': '#f06c00',
  '--nylas-success': '#16a392',
  '--nylas-info': '#2b8fc2',
  '--nylas-base-0': '#ffffff',
  '--nylas-base-25': '#fcfcfd',
  '--nylas-base-50': '#f8f9fc',
  '--nylas-base-100': '#eaecf5',
  '--nylas-base-200': '#ebebeb',
  '--nylas-base-300': '#727272', // '#b3b8d8'
  '--nylas-base-400': '#717bbc',
  '--nylas-base-500': '#bea06e',
  '--nylas-base-600': '#3d3d3d',
  '--nylas-base-700': '#3d3d3d', // '#263f72'
  '--nylas-base-800': '#2b2b2b',
  '--nylas-base-900': '#101323',
  '--nylas-base-950': '#0e101b',
  '--nylas-border-radius': '0',
  '--nylas-border-radius-2x': '0',
  '--nylas-border-radius-3x': '0',
  '--nylas-font-family': '"Montserrat", sans-serif',
};
